import { z } from 'zod';
import { BrandedId, ScenarioTypeSchema, StrategySchema } from './common.js';

export const BufferRuleSchema = z.object({
  minPartySize: z.number().int().positive(),
  maxPartySize: z.number().int().positive().nullable(),
  buffer: z.number().int().nonnegative(),
});

// GET /api/manager/policy-sets/:id
export const PolicySetView = z.object({
  policySetId: BrandedId,
  version: z.number().int().positive(),
  scenarioType: ScenarioTypeSchema,
  capacity: z.object({
    minPartySize: z.number().int().positive(),
    maxPartySize: z.number().int().positive(),
    bufferRules: z.array(BufferRuleSchema),
  }),
  scheduling: z.object({
    durationMinMinutes: z.number().int().positive(),
    durationMaxMinutes: z.number().int().positive(),
    extensionAllowed: z.boolean(),
  }),
  allocation: z.object({
    strategy: StrategySchema,
    continuousRequired: z.boolean(),
  }),
});

// GET /api/manager/audit-logs
export const AuditEntryView = z.object({
  auditId: BrandedId,
  action: z.string(),
  actorRole: z.enum(['guest', 'staff', 'manager', 'system']),
  createdAt: z.string(),
  payload: z.record(z.unknown()),
});

export const AuditTrailResponse = z.object({
  entries: z.array(AuditEntryView),
});
